<template>
  <div>
    <v-dialog v-model="dialog" persistent :max-width="filterWdh">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="primary text-capitalize f-14 lh-17"
          :class="
            title === 'Spending Approval'
              ? 'mt-3 mr-3'
              : title === 'Budget Report'
              ? 'mr-0 ml-3'
              : 'mt-2 mr-3'
          "
          @click="openFilterDialog"
        >
          <v-icon left>mdi-filter-outline</v-icon> Filter
        </v-btn>
      </template>

      <v-card class="rounded-12">
        <v-card-title
          class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
        >
          <img
            src="@/assets/images/icon/filter.png"
            width="20px"
            class="mr-3"
          />
          <span class="pa-0">{{ title }} Filter</span>
          <v-spacer></v-spacer>
          <v-icon
            @click="dialog = false"
            color="white"
            class="fs-18"
            style="font-size: 20px !important; margin-right: -4px !important"
          >
            close
          </v-icon>
        </v-card-title>
        <v-card-text class="pb-0 px-3 border-b-1">
          <v-container class="py-0 form-filter">
            <v-row>
              <v-col class="pt-4">
                <h4 class="primary--text lh-17 mb-2">
                  Filter By
                </h4>
                <div
                  v-if="showFilterDivision"
                  :class="
                    filter === 'divisi'
                      ? 'menuActive--text font-weight-600'
                      : ''
                  "
                  class="pt-3 pb-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('divisi')"
                >
                  <span class="fs-12">Division</span>
                </div>
                <div
                  v-if="showFilterHouse"
                  :class="
                    filter === 'house' ? 'menuActive--text font-weight-600' : ''
                  "
                  class="py-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('house')"
                >
                  <span class="fs-12">{{ titleHouse }}</span>
                </div>
                <div
                  v-if="showFilterDept"
                  :class="
                    filter === 'department'
                      ? 'menuActive--text font-weight-600'
                      : ''
                  "
                  class="py-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('department')"
                >
                  <span class="fs-12">
                    {{
                      titleHouse === 'House/Dept'
                        ? 'Dept/Category'
                        : titleHouse === 'Department'
                        ? 'Category'
                        : 'Department'
                    }}
                  </span>
                </div>
                <div
                  :class="
                    filter === 'budgetOwner'
                      ? 'menuActive--text font-weight-600'
                      : ''
                  "
                  class="py-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('budgetOwner')"
                >
                  <span class="fs-12">Budget Owner</span>
                </div>
              </v-col>
              <v-col
                v-if="divisionList.length > 0 && showFilterDivision"
                class="pt-4 border-l-1"
              >
                <h4 class="primary--text lh-17 mb-5">
                  Division
                </h4>
                <VuePerfectScrollbar
                  class="drawer-menu--scroll-filter"
                  :settings="scrollSettingsFilter"
                >
                  <div style="margin-left: -5px;">
                    <v-checkbox
                      v-for="(division, index) in divisionList"
                      :key="'filter' + index"
                      v-model="divisionObjSelect"
                      :label="division.name"
                      @change="divisionChanged(division)"
                      :value="division.id"
                      color="menuActive"
                    >
                    </v-checkbox>
                  </div>
                </VuePerfectScrollbar>
              </v-col>
              <v-col
                class="pt-4 border-l-1"
                v-if="houseList.length > 0 && showFilterHouse"
              >
                <h4
                  v-if="titleHouse === 'House/Dept' || titleHouse === 'House'"
                  class="primary--text lh-17 mb-5"
                >
                  House
                </h4>
                <div
                  v-if="titleHouse === 'House/Dept' || titleHouse === 'House'"
                  style="margin-left: -5px;"
                >
                  <template v-for="(house, index) in houseList">
                    <v-checkbox
                      :key="'filter' + index"
                      v-if="house.type === 'house'"
                      v-model="houseObjSelect"
                      :label="house.name"
                      @change="houseChanged(house)"
                      :value="house.id"
                      color="menuActive"
                    >
                    </v-checkbox>
                  </template>
                </div>
                <h4
                  v-if="titleHouse !== 'House'"
                  class="primary--text lh-17 mb-5"
                >
                  Department
                </h4>
                <VuePerfectScrollbar
                  :class="
                    titleHouse === 'House/Dept'
                      ? 'drawer-menu--scroll-filterDept'
                      : 'drawer-menu--scroll-filter'
                  "
                  :settings="scrollSettingsFilter"
                >
                  <div v-if="titleHouse !== 'House'" style="margin-left: -5px;">
                    <template v-for="(house, index) in houseList">
                      <v-checkbox
                        :key="'filter' + index"
                        v-if="house.type === 'department'"
                        v-model="houseObjSelect"
                        :label="house.name"
                        @change="houseChanged(house)"
                        :value="house.id"
                        color="menuActive"
                      >
                      </v-checkbox>
                    </template>
                  </div>
                </VuePerfectScrollbar>
              </v-col>
              <v-col
                class="pt-4 border-l-1"
                v-if="deptList.length > 0 && showFilterDept"
              >
                <h4
                  v-if="titleHouse !== 'Department'"
                  class="primary--text lh-17 mb-5"
                >
                  Department
                </h4>
                <VuePerfectScrollbar
                  :class="
                    titleHouse === 'House/Dept'
                      ? 'drawer-menu--scroll-filterDept'
                      : 'drawer-menu--scroll-filter'
                  "
                  :settings="scrollSettingsFilter"
                >
                  <div style="margin-left: -5px;">
                    <template v-for="(dept, index) in deptList">
                      <v-checkbox
                        :key="'filter' + index"
                        v-if="dept.type === 'department'"
                        v-model="deptObjSelect"
                        :label="dept.name"
                        @change="deptChanged(dept)"
                        :value="dept.id"
                        color="menuActive"
                      >
                      </v-checkbox>
                    </template>
                  </div>
                </VuePerfectScrollbar>
                <h4
                  v-if="titleHouse !== 'House'"
                  class="primary--text lh-17 mb-5"
                >
                  Category
                </h4>
                <VuePerfectScrollbar
                  :class="
                    titleHouse === 'House/Dept'
                      ? 'drawer-menu--scroll-filterDept'
                      : 'drawer-menu--scroll-filter'
                  "
                  :settings="scrollSettingsFilter"
                >
                  <div style="margin-left: -5px;">
                    <template v-for="(dept, index) in deptList">
                      <v-checkbox
                        :key="'filter' + index"
                        v-if="dept.type === 'category'"
                        v-model="deptObjSelect"
                        :label="dept.name"
                        @change="deptChanged(dept)"
                        :value="dept.id"
                        color="menuActive"
                      >
                      </v-checkbox>
                    </template>
                  </div>
                </VuePerfectScrollbar>
              </v-col>
              <v-col class="pt-4 border-l-1" v-if="boList.length > 0">
                <h4 class="primary--text lh-17 mb-5">
                  Budget Owner
                </h4>
                <VuePerfectScrollbar
                  class="drawer-menu--scroll-filter"
                  :settings="scrollSettingsFilter"
                >
                  <div style="margin-left: -5px;">
                    <v-checkbox
                      v-for="(bo, index) in boList"
                      :key="'filter' + index"
                      v-model="boObjSelect"
                      :label="bo.name"
                      :value="bo.id"
                      color="menuActive"
                    >
                    </v-checkbox>
                  </div>
                </VuePerfectScrollbar>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="py-3 px-6">
          <v-btn
            color="primary"
            dark
            class="rounded-6 text-capitalize px-4"
            @click="resetFilter"
          >
            Reset Filter
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="rounded-6 text-capitalize px-4"
            dark
            @click="setFilter()"
          >
            View Data
          </v-btn>
          <v-btn
            v-if="title !== 'Spending Approval'"
            color="menuActive"
            class="rounded-6 text-capitalize"
            dark
            @click="downloadFile"
          >
            Download
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import { mapGetters, mapState } from 'vuex';
import { arrayToParam } from '@/utils/helpers';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';

export default {
  components: {
    VuePerfectScrollbar
  },
  mixins: [LoginAsMixin],
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      scrollSettingsFilter: {
        maxScrollbarLength: 283
      },
      initializing: false,
      dialog: false,
      showFilterDivision: false,
      showFilterHouse: false,
      showFilterDept: false,
      showFilterBo: false,
      divisionObjSelect: [],
      houseObjSelect: [],
      deptObjSelect: [],
      boObjSelect: [],
      divisionList: [],
      houseList: [],
      deptList: [],
      boList: [],
      filterWdh: '30%',
      filter: '',
      filters: []
    };
  },
  computed: {
    ...mapState('auth', ['userRole']),
    ...mapGetters('auth', ['userMapping']),
    titleHouse() {
      let division = this.divisionObj.map(item => {
        return item.name;
      });
      if (division.includes('HN') && division.length > 1) {
        return 'House/Dept';
      } else if (
        (division.length === 1 && division[0] === 'HN') ||
        this.isLoggedInAsHN
      ) {
        return 'Department';
      } else {
        return 'House';
      }
    },
    divisionObj() {
      return this.divisionList.filter(item =>
        this.divisionObjSelect.some(itemselect => item.id === itemselect)
      );
    },
    houseObj() {
      return this.houseList.filter(item =>
        this.houseObjSelect.some(itemselect => item.id === itemselect)
      );
    },
    deptObj() {
      return this.deptList.filter(item =>
        this.deptObjSelect.some(itemselect => item.id === itemselect)
      );
    },
    boObj() {
      return this.boList.filter(item =>
        this.boObjSelect.some(itemselect => item.id === itemselect)
      );
    },
    division_ids() {
      const { division } = this.defaultParams;
      return [...division, ...this.divisionObj.map(item => item.id)];
    },
    house_ids() {
      const { house } = this.defaultParams;
      return [...house, ...this.houseObj.map(item => item.id)];
    },
    dept_ids() {
      const { dept } = this.defaultParams;
      return [...dept, ...this.deptObj.map(item => item.id)];
    },
    bo_ids() {
      const { bo } = this.defaultParams;
      return [...bo, ...this.boObj.map(item => item.id)];
    },
    division_ids_param() {
      return arrayToParam(this.division_ids);
    },
    house_ids_param() {
      return arrayToParam(this.house_ids);
    },
    dept_ids_param() {
      return arrayToParam(this.dept_ids);
    },
    bo_ids_param() {
      return arrayToParam(this.bo_ids);
    },
    isFilteringDivision() {
      return this.divisionNames.length > 0;
    },
    isFilteringHouse() {
      return this.houseNames.length > 0;
    },
    isFilteringDept() {
      return this.deptNames.length > 0;
    },
    isFilteringBO() {
      return this.boNames.length > 0;
    },
    divisionNames() {
      return this.divisionObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    houseNames() {
      return this.houseObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    deptNames() {
      return this.deptObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    boNames() {
      return this.boObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    filter_by() {
      const year = moment(this.year1).format('YYYY');
      const separator = this.showFilterDivision ? '/' : '';
      let filterDivision = this.showFilterDivision
        ? `${this.isFilteringDivision ? this.divisionNames : 'All Division'}`
        : '';
      let filterHouse = this.showFilterHouse
        ? `/ ${
            this.isFilteringHouse
              ? this.houseNames
              : this.isLoggedInAsHN || filterDivision === 'HN'
              ? 'All Department'
              : 'All House'
          }`
        : '';
      let filterDept = this.showFilterDept
        ? `/ ${
            this.isFilteringDept
              ? this.deptNames
              : this.isLoggedInAsHN || filterDivision === 'HN'
              ? 'All Category'
              : 'All Department'
          }`
        : '';
      let filterBO = this.showFilterBo
        ? `/ ${this.isFilteringBO ? this.boNames : 'All BO'}`
        : '';
      if (this.divisionObj.length === this.divisionList.length) {
        filterDivision = 'All Division';
      }
      if (this.houseObj.length === this.houseList.length) {
        filterHouse = '/ All House';
      }
      if (this.deptObj.length === this.deptList.length) {
        filterDept = '/ All Department';
      }
      if (this.boObj.length === this.boList.length) {
        filterBO = '/ All BO';
      }
      if (this.isLoggedInAsBO) {
        return year;
      } else {
        return `${year} ${separator} ${filterDivision} ${filterHouse} ${filterDept} ${filterBO}`;
      }
    },
    defaultParams() {
      const { mapping } = this.userRole || {};
      const { profile_id, divisi_id, house_id, dept_id } = mapping || {};

      const divisionParams = [divisi_id];
      const houseParams = [house_id];
      const deptParams = [dept_id];
      const boParams = [profile_id];

      let division = [];
      let house = [];
      let dept = [];
      let bo = [];

      if (this.isLoggedInAsDirector) {
        division = divisionParams;
      }

      if (this.isLoggedInAsBrandHead) {
        division = divisionParams;
        house = houseParams;
      }

      if (this.isLoggedInAsDeptHead) {
        division = divisionParams;
        house = houseParams;
        dept = deptParams;
      }

      if (this.isLoggedInAsBO) {
        division = divisionParams;
        house = houseParams;
        dept = deptParams;
        bo = boParams;
      }

      return {
        division,
        house,
        dept,
        bo
      };
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.filterCheck();
      }
    }
  },
  async mounted() {
    const divObj = JSON.parse(localStorage.getItem('divisionObj'));
    const deptObj = JSON.parse(localStorage.getItem('deptObj'));
    const houseObj = JSON.parse(localStorage.getItem('houseObj'));
    const boObj = JSON.parse(localStorage.getItem('boObj'));

    this.divisionObjSelect = divObj || this.divisionObjSelect;
    this.deptObjSelect = deptObj || this.deptObjSelect;
    this.houseObjSelect = houseObj || this.houseObjSelect;
    this.boObjSelect = boObj || this.boObjSelect;

    this.filters = JSON.parse(localStorage.getItem('filters'));
    if (this.isLoggedInAsHN) {
      for (let i = 0; i < this.filters.length; i++) {
        switch (this.filters[i].name) {
          case 'House':
            this.filters[i].name = 'Department';
            break;
          case 'Department':
            this.filters[i].name = 'Category';
            break;
        }
      }
    } else if (this.isLoggedInAsFinance) {
      for (let i = 0; i < this.filters.length; i++) {
        switch (this.filters[i].name) {
          case 'House':
            this.filters[i].name = 'House/Dept';
            break;
          case 'Department':
            this.filters[i].name = 'Dept/Category';
            break;
        }
      }
    }
    await this.filterCheck();
    // const divisionIds = this.division_ids;
    // let houseIds = this.house_ids;
    // const departmentIds = this.dept_ids;
    // const budgetOwnerIds = this.bo_ids;

    // const deptNoHouse = this.isLoggedInAsDeptHead && !this.userMapping.house_id;

    // if (deptNoHouse) {
    //   houseIds = this.houseList.map(item => item.id);
    // }
    // await this.$emit('paramAdvanceFilter', {
    //   divisionIds: divisionIds,
    //   houseIds: houseIds,
    //   departmentIds: departmentIds,
    //   budgetOwnerIds: budgetOwnerIds,
    //   filter_by: this.filter_by
    // });
    this.filterGroup();
    this.initializing = false;
  },
  methods: {
    openFilterDialog() {
      this.$emit('openDialog');
    },
    getDivision() {
      return this.$store
        .dispatch('advanceFilter/getDivision')
        .then(data => {
          if (data.code === 200) {
            this.divisionList = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getHouses() {
      this.isDisabledHouse = true;
      return this.$store
        .dispatch('advanceFilter/getHouse')
        .then(data => {
          this.isDisabledHouse = false;
          if (data.code === 200) {
            this.houseList = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getDept() {
      this.isDisabledDept = true;
      let division = this.division_ids_param;
      let house = this.house_ids_param;
      let params = {
        division_id: division,
        house_id: house
      };
      return this.$store
        .dispatch('advanceFilter/getDept', params)
        .then(data => {
          this.isDisabledDept = false;
          if (data.code === 200) {
            this.deptList = data.data;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getBO() {
      this.isDisabledBo = true;
      let dept = this.dept_ids_param;
      let house = this.house_ids_param;
      if (this.isLoggedInAsDeptHead && !this.userMapping.house_id) {
        house = arrayToParam(this.houseList.map(item => item.id));
      }
      let params = {
        house_id: house,
        department_id: dept
      };
      return this.$store
        .dispatch('advanceFilter/getBO', params)
        .then(data => {
          this.isDisabledBo = false;
          if (data.code === 200) {
            this.boList = data.data;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    async filterCheck() {
      let profName = JSON.parse(localStorage.getItem('userProfile'));
      switch (this.filters.length) {
        case 1:
          this.showFilterDivision = false;
          this.showFilterHouse = false;
          this.showFilterDept = false;
          this.showFilterBo = false;
          break;
        case 2: // BO
          this.showFilterDivision = false;
          this.showFilterHouse = false;
          this.showFilterDept = false;
          this.showFilterBo = true;
          await this.getBO();
          break;
        case 3: // Dept
          this.showFilterDivision = false;
          this.showFilterHouse = false;
          this.showFilterDept = true;
          this.showFilterBo = true;
          await this.getDept();
          break;
        case 4: // House
          this.showFilterDivision = false;
          this.showFilterHouse = true;
          this.showFilterDept = true;
          this.showFilterBo = true;
          break;
      }
      if (profName.desc.includes('Finance')) {
        this.showFilterDivision = true;
        await this.getDivision();
      } else {
        this.showFilterDivision = false;
        await this.getHouses();
      }
      if (this.fromDetail == 'true') {
        await this.getDivision();
        await this.getHouses();
        await this.getDept();
        await this.getBO();
      }
    },
    downloadFile() {
      this.$emit('downloadbyFilter', {
        divisionId: this.division_ids,
        houseId: this.house_ids,
        deptId: this.dept_ids,
        boId: this.bo_ids,
        houseList: this.houseList
      });
    },
    getSummaryAmount() {
      this.$emit('getSummary');
    },
    async setFilter() {
      this.showFilterDialog = false;
      if (this.title !== 'Budget Report') {
        await this.getSummaryAmount();
      }
      const divisionIds = this.division_ids;
      let houseIds = this.house_ids;
      const departmentIds = this.dept_ids;
      const budgetOwnerIds = this.bo_ids;

      const deptNoHouse =
        this.isLoggedInAsDeptHead && !this.userMapping.house_id;

      if (deptNoHouse) {
        houseIds = this.houseList.map(item => item.id);
      }
      if (this.title !== 'Budget Report') {
        this.$emit('resetTab');
      }
      if (this.divisionObj.length > 0) {
        this.getHouses();
      }
      if (this.houseObj.length > 0) {
        this.getDept();
      }
      if (this.deptObj.length > 0) {
        this.getBO();
      }
      if (this.title !== 'Budget Report') {
        this.$emit('setTab', {
          house_ids: houseIds,
          division_ids: divisionIds,
          dept_ids: departmentIds,
          bo_ids: budgetOwnerIds,
          filter: this.filter,
          filters: this.filters
        });
      }
      await this.filterCheck();
      this.$emit('paramAdvanceFilter', {
        divisionIds: divisionIds,
        houseIds: houseIds,
        departmentIds: departmentIds,
        budgetOwnerIds: budgetOwnerIds,
        divisionObj: this.divisionObj,
        deptObj: this.deptObj,
        houseObj: this.houseObj,
        boObj: this.boObj,
        filter_by: this.filter_by
      });
      this.dialog = false;
    },
    async changeFilter(filter) {
      this.filter = filter;
      this.reset();
      if (filter === 'divisi') {
        this.filterWdh = this.wdhFilter('divisi');
        if (this.isLoggedInAsFinance || this.isLoggedInAsDirector) {
          this.divisionObjSelect = [];
        }
      }
      if (filter === 'house') {
        this.filterWdh = this.wdhFilter('house');
        if (this.isLoggedInAsFinance) {
          await this.getDivision();
          this.divisionObjSelect = this.divisionList.map(item => item.id);
          await this.getHouses();
        }
        if (this.isLoggedInAsDirector) {
          await this.getHouses();
        }
        if (this.isLoggedInAsBrandHead) {
          await this.getDept();
        }
      }
      if (filter === 'department') {
        this.filterWdh = this.wdhFilter('department');
        if (this.isLoggedInAsFinance) {
          await this.getDivision();
          this.divisionObjSelect = this.divisionList.map(item => item.id);
          await this.getHouses();
          this.houseObjSelect = this.houseList.map(item => item.id);
          await this.getDept();
        }
        if (this.isLoggedInAsDirector) {
          await this.getHouses();
          this.houseObjSelect = this.houseList.map(item => item.id);
          await this.getDept();
        }
        if (this.isLoggedInAsBrandHead) {
          this.reset();
        }
      }
      if (filter === 'budgetOwner') {
        this.filterWdh = this.wdhFilter('budgetOwner');
        if (this.isLoggedInAsFinance) {
          await this.getDivision();
          this.divisionObjSelect = this.divisionList.map(item => item.id);
          await this.getHouses();
          this.houseObjSelect = this.houseList.map(item => item.id);
          await this.getDept();
          this.deptObjSelect = this.deptList.map(item => item.id);
          await this.getBO();
        }
        if (this.isLoggedInAsDirector) {
          await this.getHouses();
          this.houseObjSelect = this.houseList.map(item => item.id);
          await this.getDept();
          this.deptObjSelect = this.deptList.map(item => item.id);
          await this.getBO();
        }
        if (this.isLoggedInAsBrandHead) {
          await this.getDept();
          this.deptObjSelect = this.deptList.map(item => item.id);
        }
      }
    },
    divisionChanged(val) {
      if (val.length !== 0) {
        this.filterWdh = this.wdhFilter('house');
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.resetHouse();
          this.resetDept();
          this.resetBO();
          this.getHouses();
        }, 900);
      }
    },
    houseChanged(val) {
      if (val.length !== 0) {
        this.filterWdh = this.wdhFilter('department');
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.resetDept();
          this.resetBO();
          this.getDept();
        }, 900);
      }
    },
    deptChanged(val) {
      this.boObjSelect = [];
      if (val.length !== 0) {
        this.filterWdh = this.wdhFilter('budgetOwner');
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if (!this.initializing) {
            this.resetBO();
          }
          this.getBO();
        }, 900);
      }
    },
    filterGroup() {
      if (this.isLoggedInAsFinance) {
        this.filter = 'divisi';
        this.filterWdh = this.wdhFilter('divisi');
      }
      if (this.isLoggedInAsDirector) {
        this.filter = 'house';
        this.filterWdh = this.wdhFilter('house');
      }
      if (this.isLoggedInAsBrandHead) {
        this.filter = 'department';
        this.filterWdh = this.wdhFilter('department');
      }
      if (this.isLoggedInAsDeptHead) {
        this.filter = 'budgetOwner';
        this.filterWdh = this.wdhFilter('budgetOwner');
      }
    },
    resetDiv() {
      if (this.initializing || !this.showFilterDivision) return;

      this.divisionList = [];
      this.divisionObjSelect = [];
    },
    resetHouse() {
      if (this.initializing || !this.showFilterHouse) return;

      this.houseList = [];
      this.houseObjSelect = [];
    },
    resetDept() {
      if (this.initializing || !this.showFilterDept) return;

      this.deptList = [];
      this.deptObjSelect = [];
    },
    resetBO() {
      // if (!this.showFilterBo) return;

      this.boObjSelect = [];
      this.boList = [];
    },
    resetFilter() {
      this.filterGroup();
      this.reset();
    },
    reset() {
      this.resetDiv();
      this.resetHouse();
      this.resetDept();
      this.resetBO();
      this.filterCheck();
    }
  }
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.drawer-menu--scroll {
  max-height: 250px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
.drawer-menu--scroll-filter {
  max-height: 396px;
  overflow: auto;
}
.drawer-menu--scroll-filterDept {
  max-height: 170px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
</style>
